import React, { Fragment, useState, useEffect, useReducer, useRef } from "react";
import { Input } from '../core/Forms';
import { useApi } from '../../services/api';
import PhoneNumber from './PhoneNumber';


function UpdateRecoveryDetails({ recoveryIntent, getRecoveryIntent }){

	const [recoveryDetails, setRecoveryDetails] = useState();
	const emailFormRef = useRef();
	
	useEffect( () => {
		if(recoveryIntent.isError){
		}else if(recoveryIntent.isLoading){
		}else if(recoveryIntent.data){
			const intent = recoveryIntent.data.recovery_intent;
			setRecoveryDetails(intent.update_recovery_details);
		}
	}, [recoveryIntent]);


	function submitEmail(event){
		event.preventDefault();
		
		const email = event.target['email'].value;
		const update_recovery_details = { email }

		getRecoveryIntent({ 
			url: `/api/v1/provisioning/recovery_intents/${recoveryIntent.data.recovery_intent.id}`,
			method: 'PUT',
			data: { recovery_intent: { update_recovery_details } } 
		});

		return false;
	}

	function submitPhone(phone_number){
		const recovery_intent = { 
			update_recovery_details: { phone_number } };
		
		getRecoveryIntent({
			url: `/api/v1/provisioning/recovery_intents/${recoveryIntent.data.recovery_intent.id}`,
			method: 'PUT',
			data: { recovery_intent }
		});
	}

	function submitCode(confirmation_code){
		const recovery_intent = { 
			update_recovery_details: { 
				phone_number: { confirmation_code } } };
		

		getRecoveryIntent({
			url: `/api/v1/provisioning/recovery_intents/${recoveryIntent.data.recovery_intent.id}`,
			method: 'PUT',
			data: { recovery_intent }
		});
	}

	function sendInstructions(event){
		event.preventDefault();

		const update_recovery_details = { send_instructions: true };

		if(emailFormRef.current){
			const email = emailFormRef.current['email'].value;
			if(email){
				update_recovery_details.email = email; }
		}

		getRecoveryIntent({
			url: `/api/v1/provisioning/recovery_intents/${recoveryIntent.data.recovery_intent.id}`,
			method: 'PUT',
			data: { recovery_intent: { update_recovery_details } }
		});

		return false;
	}

	let phoneNumber = null;
	
	if(recoveryDetails && recoveryDetails.phone_number){
		phoneNumber = recoveryDetails.phone_number; }

	let emailValid = null;
	if(recoveryDetails){
		if(recoveryDetails.email_invalid){
			emailValid = false; 
		}else if(recoveryDetails.email){
			emailValid = true; }
	}

	let continueDisabled = false;
	if(recoveryDetails && !recoveryDetails.email){
		continueDisabled = true; 
	}if(recoveryIntent.isLoading){
		continueDisabled = true; }

	return (<Fragment>
		<h2>Evita problemas para iniciar sesión</h2>
		<p className="text-muted mb-3">Muchos usuarios olvidan su contraseña después de entrar a Saeko es por eso que te pedimos actualizar tus datos para evitar que no puedas entrar.</p>

		{phoneNumber && <PhoneNumber 
			submitPhone={submitPhone}
			submitCode={submitCode}
			phoneNumber={phoneNumber}
			isLoading={recoveryIntent.isLoading}
			canEdit={!phoneNumber.confirmed} />}

		<div className="border-top border-white d-block w-100"></div>
		<div className="border-top border-dark d-block w-100 p-3"></div>
		
		<form ref={emailFormRef} onSubmit={submitEmail}>
			<div className="form-row">
				<Input name="email" label="Correo Electrónico (Requerido)" className="form-group col-8"
					initialValueObject={recoveryDetails} initialValueKey="email"
					description="Aquí recibirás un enlace para poder recuperar tu cuenta"
					isValid={emailValid} />

				<div className="form-group col-4">
					<button type="submit" className="btn btn-secondary w-100 mt-4" disabled={recoveryIntent.isLoading}>
						{recoveryIntent.isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
						{recoveryDetails && recoveryDetails.email ? 
							'Cambiar' : 'Guardar'}
					</button>
				</div>
			</div>
		</form>

		<div className="border-top border-white d-block w-100"></div>
		<div className="border-top border-dark d-block w-100 p-3"></div>

		<button type="button" className="btn btn-primary w-100" onClick={sendInstructions} disabled={continueDisabled}>
			{recoveryIntent.isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
			Continuar
		</button>
	</Fragment>);
}

export default UpdateRecoveryDetails;
